<h2>Ügyindítások a kiválasztott időszakban (ügyvédi iroda és termék szerint)</h2>
@if (loading()) {
  <mat-progress-spinner
    mode="indeterminate"
    diameter="40"
  ></mat-progress-spinner>
}
@if (!loading()) {
  <table
    mat-table
    class="case-starts-by-law-firm-table"
    [dataSource]="data"
  >
    <ng-container matColumnDef="law_firm_name">
      <th
        *matHeaderCellDef
        mat-header-cell
      >
        Ügyvédi iroda
      </th>
      <td
        *matCellDef="let row"
        mat-cell
      >
        {{ row.law_firm_name }}
      </td>
    </ng-container>
    <ng-container matColumnDef="product_label">
      <th
        *matHeaderCellDef
        mat-header-cell
      >
        Termék
      </th>
      <td
        *matCellDef="let row"
        mat-cell
      >
        {{ row.product_label }}
      </td>
    </ng-container>
    <ng-container matColumnDef="count">
      <th
        *matHeaderCellDef
        mat-header-cell
      >
        Darab
      </th>
      <td
        *matCellDef="let row"
        mat-cell
      >
        {{ row.count }}
      </td>
    </ng-container>
    <ng-container matColumnDef="paid_payee_fee_amount">
      <th
        *matHeaderCellDef
        mat-header-cell
      >
        Kifizetett ügyindítási díj
      </th>
      <td
        *matCellDef="let row"
        mat-cell
      >
        @if ((row.paid_payee_fee_by_currency | keyvalue)?.length) {
          @for (fee of row.paid_payee_fee_by_currency | keyvalue; track fee.key; let last = $last) {
            <span>
              {{ $any(fee.value) | number: "1.0-0" : "hu" }} {{ fee.key }}
              @if (!last) {
                <span>|</span>
              }
            </span>
          }
        } @else {
          -
        }
      </td>
    </ng-container>
    <tr
      *matHeaderRowDef="['law_firm_name', 'product_label', 'count', 'paid_payee_fee_amount']"
      mat-header-row
    ></tr>
    <tr
      *matRowDef="let row; columns: ['law_firm_name', 'product_label', 'count', 'paid_payee_fee_amount']"
      mat-row
    ></tr>
  </table>
}
